import noImage from "../../../assets/images/noImage.png";
import { useTranslation } from "react-i18next";

export default function ShopifyProductList({ ShopifyProducts }) {
  const { t } = useTranslation("sales");
  return (
    <>
      {ShopifyProducts?.length > 0 && (
        <div className="sss__products_section">
          <div className="sss__addressection_heading">{t("syncedProducts")}</div>
          <div className="overflow-x-auto">
            <div className="min-w-[800px] w-full mx-auto">
              {/* Header Row */}
              <div className="flex text-sm font-medium py-2">
                <div className="flex-1 text-center">{t("products")}</div>
                <div className="flex-1 text-center">{t("name")}</div>
                <div className="flex-1 text-center">{t("skuCaps")}</div>
                <div className="flex-1 text-center">{t("sizeLwh")}</div>
                <div className="flex-1 text-center">{t("weight")}</div>
                <div className="flex-1 text-center">{t("quantity")}</div>
                <div className="flex-1 text-center">{t("itemValue")}</div>
              </div>

              {/* Product Rows */}
              {ShopifyProducts?.map((singlelist, index) => (
                <div key={index} className="flex items-center text-sm py-2">
                  <div className="flex-1 flex items-center justify-center gap-2">
                    <span>#{index + 1}</span>
                    <img
                      src={singlelist?.shopify_image ?? noImage}
                      onError={(e) => {
                        e.target.src = noImage;
                      }}
                      className="w-10 h-10 rounded object-contain"
                      alt={t("product")}
                    />
                  </div>
                  <div className="flex-1 text-center">
                    {singlelist?.product_name}
                  </div>
                  <div className="flex-1 text-center">{singlelist?.sku}</div>
                  <div className="flex-1 text-center">
                    {singlelist?.length ?? "0"}×{singlelist?.width ?? "0"}×
                    {singlelist?.height ?? "0"} {singlelist?.dimension_unit}
                  </div>
                  <div className="flex-1 text-center">
                    {singlelist?.weight ?? "0"} {singlelist?.weight_unit}
                  </div>
                  <div className="flex-1 text-center">
                    {singlelist?.item_quantity ?? "0"}
                  </div>
                  <div className="flex-1 text-center">
                    {singlelist?.item_total ?? "0"}$
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
